import useIsServer from 'hooks/useIsServer';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import isMobile from 'store/app/selector/isMobile';
import getAddingToCartFlow from 'store/product/selector/getAddingToCartFlow';
import { AddToCartFlow } from 'store/product/types';

const increaseElementValue = (element: HTMLElement | undefined | null) => {
  if (!(element instanceof HTMLElement)) {
    return;
  }

  element.innerHTML = String(Number(element.innerText.trim()) + 1);

  if (element.style.display === 'none') {
    element.style.removeProperty('display');
  }
};

const updateMobileCounter = () => {
  const element = document.querySelector<HTMLElement>('.icon-shopping-cart');
  const counterElement = element?.parentElement?.querySelector<HTMLElement>('.badge');
  increaseElementValue(counterElement);
};

const updateDesktopCounter = () => {
  const element = document.querySelector<HTMLElement>('.icon-shopping-cart .op-header_acc-item_bubble');
  increaseElementValue(element);
};

const AddToBasketCounterTracker = () => {
  const isServer = useIsServer();
  if (isServer) {
    return null;
  }

  const addToCartFlow = useSelector(getAddingToCartFlow);
  const isMobileDevice = useSelector(isMobile);
  const increment = isMobileDevice ? updateMobileCounter : updateDesktopCounter;

  useEffect(() => {
    if (addToCartFlow !== AddToCartFlow.addedToCart) {
      return;
    }
    increment();
  }, [addToCartFlow]);

  return null;
};

export default AddToBasketCounterTracker;
